
import { Component, Vue, Watch, Prop, Emit, Mixins } from "vue-property-decorator";
import { namespace, Getter, Mutation } from "vuex-class";
import { DispatchRequest, UnavailableStatus, DispatchType } from "@/store/mobile/types";
import MobileInfoWindow from "@/components/mobile/core/MobileInfoWindow.vue";
import DispatchMixin from "@/mixins/DispatchMixin";

const Mobile = namespace("mobile");
@Component
export default class DispatchInfoWindow extends Mixins(DispatchMixin, MobileInfoWindow) {
	// Feature toggle
	@Getter("getFeature") getFeature: (featureName: string[]) => boolean;
	@Mobile.Mutation setAlmostArrived: (almostArrived: boolean) => void;
	@Mobile.Action guardArrived: ({dispatchQueueId: number, hasArrived: boolean}) => Promise<void>;
	@Mobile.Getter getDispatchRequest: (dispatchRequestId: number) => DispatchRequest;
	@Mobile.Action inactivateDispatchRequest: (dispatchRequestId: number) => Promise<void>;
	@Mobile.Action activateDispatchRequest: (dispatchRequestId: number) => Promise<void>;
	@Mobile.Getter("getActiveDispatchRequest") activeDispatchRequest: DispatchRequest;
	@Mobile.State(state => state.CurrentTour) tour: any; // FIXME Add type GuardTour from guard tour store
	@Mobile.Mutation setNotificationText: any;

	// Guard check in
	@Mobile.State(state => state.DispatchGuard.manualLocationUpdate) manualLocationUpdate: boolean;
	@Mobile.State(state => state.DispatchGuard.currentTourStepIdentifier) currentTourStepIdentifier: string;
	@Mobile.Action loadCurrentTourStepIdentifier: (tourStepId: number) => Promise<void>;
	@Mobile.Mutation setCurrentTourStepIdentifier: (identifier: string) => Promise<void>;

	@Prop(Number) dispatchRequestId;

	@Watch("dispatchRequestId")
	onDispatchRequestIdChanged(value: number, oldValue: number) {
		this.dispatchRequest = this.getDispatchRequest(value);
		this.setInfoWindowTitle(this.dispatchRequest);
	}

	@Emit("closeInfoWindow")
	private closeInfoWindow() {}

	private title = "";
	private dispatchRequest: DispatchRequest;
	private active = false;

	private get isMobileCheckInEnabled(): boolean {
		return this.getFeature(["Mobile", "CheckIn"]);
	}

	private setInfoWindowTitle(dispatchRequest: DispatchRequest) {
		this.title = this.dispatchRequest.areaTitle + ": " + this.dispatchRequest.serverTypeEventTitle;
	}

	public async openInfoWindow(dispatchRequestId: number) {
		// If guard needs to check in at asset, prompt them to do so.
		if(this.isMobileCheckInEnabled && this.manualLocationUpdate && this.activeDispatchRequest.dispatchType == DispatchType.Tour) {
			const tourStepId = this.activeDispatchRequest.objectId;

			this.setCurrentTourStepIdentifier("");
			this.loadCurrentTourStepIdentifier(tourStepId).then(() => {
				if (this.currentTourStepIdentifier && this.currentTourStepIdentifier.length > 0) {
					this.setNotificationText("Please check in first before completing");
				}
			})
		}

		this.dispatchRequest = this.getDispatchRequest(dispatchRequestId);
		this.setInfoWindowTitle(this.dispatchRequest);
		this.active = this.dispatchRequest.active; // local var because dispatchRequest could be null
	}

	private activateToggle() {
		this.setAlmostArrived(false);

		if (this.dispatchRequest.active) {
			this.inactivateDispatchRequest(this.dispatchRequest.dispatchQueueID);
		} else {
			this.activateDispatchRequest(this.dispatchRequest.dispatchQueueID);
		}
		this.closeInfoWindow();
	}

	private markAsArrived() {
		this.guardArrived({dispatchQueueId: this.dispatchRequest.dispatchQueueID, hasArrived: true});
		this.closeInfoWindow();
	}

	private dispatchClasses() {
		if (this.dispatchRequest) {
			return this.dispatchTypeBackgroundClasses(this.dispatchRequest);
		}

		return {}
	}
}
